import { t } from '../i18n';

/**
 * Shown for any unknown route, and (from User Story 3 onward) for a cellar
 * a regular user may not access — deliberately identical either way, so it
 * reveals nothing about whether the cellar exists (contracts/storage-and-
 * permissions.md: "access denied" and "does not exist" look the same).
 */
export function NotFoundPage() {
  return (
    <main>
      <h1>{t('notFound.title')}</h1>
      <p>{t('notFound.body')}</p>
    </main>
  );
}
